import { Status } from "./Status";

export class RangeStatusSmartEnum {
    static Packed = new Status("Packed", 1, "pill--green");
    static Disposed = new Status("Disposed", 2, "pill--red");
    static Disposing = new Status("Disposing", 3, "pill--orange");
    static Merged = new Status("Merged", 4, "pill--blue");
    static Recalling = new Status("Recalling", 5, "pill--blue");
    static Recalled = new Status("Recalled", 6, "pill--blue");
    static Invalid = new Status("Not Found", 7, "pill--red", "Invalid"); // Even though the state is technically invalid, cellnass want it displaying as not found
    static Picked = new Status("Picked", 10, "pill--orange");
    static Mixed = new Status("Mixed", 11, "pill--yellow");
    static Unknown = new Status("Unknown", 12, "pill--grey");
    static Created = new Status("Created", 13, "pill--grey");

    public static getName() {
        // Cannot use this.name as it will be the minified value in production
        return "RangeStatusSmartEnum";
    }
}
